/**
 * Utility functions for handling RLS (Row Level Security) related errors
 */

/**
 * Check if an error is related to RLS policy violations
 */
export function isRLSError(error: any): boolean {
  if (!error) return false;
  
  // Common RLS error patterns
  const rlsErrorPatterns = [
    'PGRST116', // PostgREST: no rows returned
    'row-level security',
    'insufficient_privilege',
    'permission denied',
    'access denied',
    'policy violation'
  ];

  const errorMessage = error.message?.toLowerCase() || '';
  const errorCode = error.code || '';

  return rlsErrorPatterns.some(pattern => 
    errorMessage.includes(pattern.toLowerCase()) || 
    errorCode.includes(pattern)
  );
}

/**
 * Convert RLS errors to user-friendly messages
 */
export function handleRLSError(error: any, context: 'referent' | 'campaign' = 'referent'): Error {
  if (!isRLSError(error)) {
    return error; // Return original error if not RLS-related
  }

  const contextMessages = {
    referent: 'Lien de référent invalide ou expiré. Veuillez vérifier que vous utilisez le bon lien.',
    campaign: 'Lien de campagne invalide ou expiré. Veuillez vérifier que vous utilisez le bon lien.'
  };

  return new Error(contextMessages[context]);
}

/**
 * Wrapper for database operations that handles RLS errors
 */
export async function withRLSErrorHandling<T>(
  operation: () => Promise<T>,
  context: 'referent' | 'campaign' = 'referent'
): Promise<T> {
  try {
    return await operation();
  } catch (_error) {
    throw handleRLSError(_error, context);
  }
}